import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { Channel } from '../../models/channel';
import { ChartModel } from '../../models/chart-model';
import { ProgramArticleStats } from '../../models/program-article-stats';
import { User } from '../../models/user';
import { ChannelService } from '../../services/channel.service';
import { ProgramArticleService } from '../../services/program-article.service';
import { IFiltersProgramArticleDashboard } from '../../store/actions/filters-program-article-dashboard.actions';
import { FiltersStateInterface } from '../../store/actions/filters.actions';
import { INITIAL_FILTERS_PROGRAM_ARTICLE_DASHBOARD_STATE } from '../../store/reducers/filters-program-article-dashboard.reducer';
import { INITIAL_FILTERS_STATE } from '../../store/reducers/filters.reducer';

@Component({
  selector: 'app-program-article-dashboard',
  templateUrl: './program-article-dashboard.component.html',
  styleUrls: ['./program-article-dashboard.component.scss']
})
export class ProgramArticleDashboardComponent implements OnInit {
  loading: boolean;
  channels: Channel[];
  // selectedChannel: number = -1;
  stats: ProgramArticleStats[];
  currentUser: User;
  destinations: string[];
  charts: ChartModel[];
  subscriptions: Subscription[] = [];
  filterSubscription: Subscription;
  filters: IFiltersProgramArticleDashboard = INITIAL_FILTERS_PROGRAM_ARTICLE_DASHBOARD_STATE;
  filtersState: FiltersStateInterface = INITIAL_FILTERS_STATE;

  colors = [{
    backgroundColor: ['#4FB65C', '#161A4B', '#CB0038']
  }];
  options = { legend: { labels: { boxWidth: 38 } } };
  constructor(private store: Store<any>,
    private channelService: ChannelService,
    private programArticleService: ProgramArticleService,
    private router: Router) { }

  ngOnInit() {
    this.loading = true;

    this.destinations = [];
    let tempDestinations = JSON.parse(localStorage.getItem('destinations')).filter(destination => destination.id != 'AllDestinations');
    
    tempDestinations.forEach(destination => {
      this.destinations.push(destination.value);
    });

    this.subscriptions.map(sub => sub.unsubscribe());

    this.subscriptions.push(this.store.select('filtersState')
      .subscribe((filters: FiltersStateInterface) => {
        this.filtersState = filters;
      }));

    this.subscriptions.push(this.store.select('userState').subscribe(user => {
      if (user && user.currentLanguage) {
        // send list of languages
        let idLanguages = [];
        idLanguages.push(user.currentLanguage);
        this.channelService.getScheduleChannels(idLanguages).subscribe(channels => {
          this.channels = channels;
          this.currentUser = user;
          if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
          }
          this.filterSubscription = this.store.select('filtersProgramArticleDashboard')
            .subscribe((filters: IFiltersProgramArticleDashboard) => {
              this.filters = filters;
              this.search();
            });
        });
      }
    }));
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.map(sub => sub.unsubscribe());
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  search() {
    this.loading = true;
    this.programArticleService
      .getStats(this.filters.selectedChannel,
        this.currentUser.currentLanguage.id,
        this.filters.startDate,
        this.filters.endDate,
        this.filters.midnightMode)
      .subscribe(stats => {
        this.stats = stats;
        this.loading = false;
        this.refreshCharts();
      });
  }

  refreshCharts() {
    this.charts = [];
    if (this.stats && this.stats.length > 0) {
      if (!this.filters.defaultDestination) {
        this.filters.defaultDestination = this.stats[0].destination;
      }
      this.stats.filter(s => s.destination === this.filters.defaultDestination.replace(" ", ""))[0].charts.forEach(chart => {
        this.charts.push(chart);
      });
    }
  }

  chartClick(event: any, chartModel: ChartModel) {
    if (event.active && event.active.length > 0) {
      const chart = event.active[0]._chart;
      const activePoints = chart.getElementAtEvent(event.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];

        this.filtersState.keywords = null;
        this.filtersState.idValue = null;
        this.filtersState.week = null;
        this.filtersState.referentialEntities = [];

        this.filtersState.startDate = this.filters.startDate;
        this.filtersState.endDate = this.filters.endDate;
        this.filtersState.field = chartModel.title;
        this.filtersState.fieldStatus = label;
        this.filtersState.channels = this.getFilteredChannels();
        this.filtersState.filterDestination = this.filters.defaultDestination;
        this.filtersState.defaultDestination = this.filters.defaultDestination;
        this.filtersState.midnightMode = this.filters.midnightMode;
        this.filtersState.fromDashboard = true;
        this.router.navigate(['/', 'program-articles']);
      }
    }
  }

  getFilteredChannels() {
    // ALL
    if (this.filters.selectedChannel === -1) {
      return this.channels.filter(c => c.id >= 0);
    }
    // LINEAR
    if (this.filters.selectedChannel === -2) {
      return this.channels.filter(c => c.isMain);
    }
    // BONUS
    if (this.filters.selectedChannel === -3) {
      return this.channels.filter(c => !c.isMain);
    }
    return this.channels.filter(c => c.id === this.filters.selectedChannel);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/program-article-dashboard/program-article-dashboard.component.ts